import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./SignUp.module.sass";
import { Link } from "react-router-dom";
import Entry from "./Entry";
import Code from "./Code";
import Image from "../../components/Image";
import auth from "../../i11/auth";
import { useUser } from "../../context/index";
import AppVersion from "../../components/Version";

const items = ["unlimited_up", "marketplace", "web3", "author"];

const SignUp = () => {
	const { locale } = useUser();
	const [visible, setVisible] = useState(true);
	const [verifyData, setVerifyData] = useState({
		username: "",
		confirmationCode: "",
	});
	const isDark = localStorage.getItem("darkMode") === "true";

	useEffect(() => {
		return () => {
			setVisible(true);
			setVerifyData({ username: "", confirmationCode: "" });
		};
	}, []);

	return (
		<div className={styles.row}>
			<div className={styles.col}>
				<div className={styles.wrap}>
					<div className={styles.preview}>
						<img
							src={`/images/logo-${
								isDark ? "light" : "dark"
							}.png`}
							alt="Login"
						/>
					</div>
					<div className={cn("h4", styles.subtitle)}>
						{auth[locale].brand_inc}
					</div>
					<ul className={styles.list}>
						{items.map((x, index) => (
							<li key={index}>{auth[locale][x]}</li>
						))}
					</ul>
				</div>
			</div>
			<div className={styles.col} style={{ minHeight: "100vh" }}>
				<div className={styles.head}>
					<Link className={styles.logo} to="/">
						<Image
							className={styles.pic}
							src="/images/logo-dark.png"
							srcDark="/images/logo-light.png"
							alt="Core"
						/>
					</Link>
					<div className={styles.info}>
						{auth[locale].already_mem}{" "}
						<Link className={styles.link} to="/sign-in">
							{auth[locale].sign_in}
						</Link>
					</div>
				</div>
				<div className={styles.wrapper}>
					<div className={cn("h2", styles.title)}>
						{auth[locale].sign_up}
					</div>
					{visible ? (
						<Entry
							onConfirm={setVisible}
							setVerifyData={setVerifyData}
						/>
					) : (
						<Code
							verifyData={verifyData}
							setVerifyData={setVerifyData}
						/>
					)}
					<AppVersion />
				</div>
			</div>
		</div>
	);
};

export default SignUp;
